import {WordEntry} from "./WordEntry";

export abstract class WordOrder {
    private map: Map<string, WordEntry[]>;

    public constructor() {
        this.map = new Map();
        this.rawWordOrder().forEach((pair: [string, [any]]) => {
            this.map.set(pair[0], pair[1]);
        })
    }

    protected abstract rawWordOrder(): any;

    public get(char: string): WordEntry[] {
        return this.map.get(char) || [];
    }
}


// WEBPACK FOOTER //
// ./src/WordOrder.ts